import Action, { ActionHome, ActionHomeError, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import HomeState from '../State/HomeState'

const actionError = (oldState: HomeState, action: Action): HomeState => {
    return { ...oldState, error: (action as ActionHomeError).message, loading: false }
}

const actionLoading = (oldState: HomeState, _action: Action): HomeState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionData = (oldState: HomeState, action: Action): HomeState => {

    let types = (action as ActionHome).types
    let properties = (action as ActionHome).properties
    let tags = (action as ActionHome).tags

    return { ...oldState, loading: false, error: undefined, types: types, properties: properties, tags: tags }
}


type Process = (oldState: HomeState, action: Action) => HomeState

export const HomeReducer: Reducer<HomeState, Action> = (state: HomeState = { types: [], properties: [], tags: [], loading: true, error: undefined }, action: Action): HomeState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.HOME_LOAGING, actionLoading)
    actionMap.set(ActionType.HOME_DATA, actionData)
    actionMap.set(ActionType.HOME_ERROR, actionError)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


